import {
  Typography,
  Box,
  Stack,
  IconButton,
  Link,
} from "@mui/material";
import { openWhatsApp, openInstagram } from "./contact_sources";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { keyframes } from "@mui/system";
import { useInView } from "./hook";
import { useNavigate,useLocation } from "react-router-dom";

const colorBreathe = keyframes`
  0%   { color: rgba(184, 118, 25, 0.7); }
  50%  { color: rgba(242, 182, 99, 0.8); }
  100% { color: rgba(243, 153, 27, 0.95); }
  
`;

export default function FooterSection() {
  const location = useLocation();
  const navigate = useNavigate();
  const [ref, show] = useInView(0.2);
  const fadeUp = (delay) => ({
    opacity: show ? 1 : 0,
    transform: show ? "translateY(0)" : "translateY(30px)",
    transition: "all 0.7s ease",
    transitionDelay: delay,
  });
  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
      return;
    }

    const section = document.getElementById(id);
    if (section) {
      const yOffset = -80;
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  return (
    <Box
      ref={ref}
      sx={{
        width: "100%",

        bgcolor: "#3e2b1e",
        borderTop: "5px solid #f29c24",
        p: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottom: "0.5px solid #494949",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
        }}
      >
        <Stack
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItem: "center",
            gap: 4,
            ...fadeUp("0.1s"),
          }}
        >
          <Box flexDirection={"row"} display={"flex"}>
            <Typography variant="h4" color="#d67617">
              Caramel
            </Typography>
            <Typography variant="h4" color="white">
              Cottage
            </Typography>
          </Box>
          <Typography
            sx={{
              maxWidth: 450,
              color: "#bfb897",
              fontSize: 15,
              fontWeight: 300,
              lineHeight: 1.5,
            }}
          >
            Bringing sweetness to your special moments. Handcrafted cakes,
            pastries, and treats made with love and the finest ingredients.
          </Typography>
          <Stack direction={"row"} spacing={2} sx={{ mb: 3 }}>
            <IconButton
              onClick={openWhatsApp}
              sx={{
                width: 40,
                height: 40,
                bgcolor: "#594132",
                transition: "transform 0.3s ease, color 0.3s ease",
                "&:hover": {
                  bgcolor: "#c5921a",
                  transform: "scale(1.15)",
                },
              }}
            >
              <WhatsAppIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              onClick={openInstagram}
              sx={{
                width: 40,
                height: 40,
                bgcolor: "#594132",
                transition: "transform 0.3s ease, color 0.3s ease",
                "&:hover": {
                  bgcolor: "#c5921a",
                  transform: "scale(1.15)",
                },
              }}
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              sx={{
                width: 40,
                height: 40,
                bgcolor: "#594132",
                transition: "transform 0.3s ease, color 0.3s ease",
                "&:hover": {
                  bgcolor: "#c5921a",
                  transform: "scale(1.15)",
                },
              }}
            >
              <FacebookOutlinedIcon sx={{ color: "white" }} />
            </IconButton>
          </Stack>
        </Stack>
        <Stack spacing={2} sx={{ ...fadeUp("0.3s") }}>
          <Typography variant="h5" sx={{ color: "#fac038" }}>
            Quick Links
          </Typography>

          {[
            { label: "Home", id: "home" },
            { label: "Menu", id: "products" },
            { label: "About Us", id: "about" },
            { label: "Contact", id: "contact" },
          ].map((item) => (
            <Link
              key={item.id}
              href="#"
              underline="none"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(item.id);
              }}
              sx={{
                color: "#b1cece",
                display: "inline-block",
                cursor: "pointer",
                transition:
                  "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.35s ease",
                "&:hover": {
                  color: "#fac038",
                  transform: "translateX(5px)",
                },
              }}
            >
              <Typography sx={{ fontSize: 14 }}>{item.label}</Typography>
            </Link>
          ))}
        </Stack>
        <Stack spacing={2} sx={{ ...fadeUp("0.5s") }}>
          <Typography variant="h5" sx={{ color: "#fac038" }}>
            Our Products
          </Typography>
          <Link
            href="#"
            underline="none"
            sx={{
              color: "#b1cece",
              display: "inline-block",
              transition:
                "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.35s ease",
              "&:hover": {
                color: "#fac038",
                transform: "translateX(5px)",
              },
            }}
          >
            <Typography sx={{ fontSize: 14 }}>Birthday Cakes</Typography>
          </Link>
          <Link
            href="#"
            underline="none"
            sx={{
              color: "#b1cece",
              display: "inline-block",
              transition:
                "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.35s ease",
              "&:hover": {
                color: "#fac038",
                transform: "translateX(5px)",
              },
            }}
          >
            <Typography sx={{ fontSize: 14 }}>Wedding Cakes</Typography>
          </Link>
          <Link
            href="#"
            underline="none"
            sx={{
              color: "#b1cece",
              display: "inline-block",
              transition:
                "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.35s ease",
              "&:hover": {
                color: "#fac038",
                transform: "translateX(5px)",
              },
            }}
          >
            <Typography sx={{ fontSize: 14 }}>Cupcakes</Typography>
          </Link>
          <Link
            href="#"
            underline="none"
            sx={{
              color: "#b1cece",
              display: "inline-block",
              transition:
                "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.35s ease",
              "&:hover": {
                color: "#fac038",
                transform: "translateX(5px)",
              },
            }}
          >
            <Typography sx={{ fontSize: 14 }}>Pastries</Typography>
          </Link>
        </Stack>
        <Box />
      </Box>
      <Box sx={{ display: "flex" }}>
        <Typography sx={{ fontSize: 13, color: "#b1cece" }}>
          © {new Date().getFullYear()} Caramel Cottage. Made with Love
          <IconButton
            sx={{
              animation: `${colorBreathe} 2.5s ease-in-out infinite`,
            }}
          >
            <FavoriteBorderIcon sx={{ fontSize: 19 }} />
          </IconButton>
        </Typography>
      </Box>
    </Box>
  );
}
